import React from 'react';
import _, {round} from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {safeSubstract} from 'common/utils';
import {BudgetUtils} from 'app-ui-componentlibrary/dist/go/components/common/BudgetUtils';
import {BOCS} from 'common/requestDetails/constants.js';
import {moveManagementFundingStreams} from 'common/requestDetails/budgetCalculation';
import {connectableObservableDescriptor} from 'rxjs/internal/observable/ConnectableObservable';

const APPSHARE_BREAKDOWN_PATH = 'share.appShare';
const APPSHARE_UPDATED_PATH = 'share.appShareUpdated';
const FEDRATE_PATH = 'share.fedRate';
const BUDGET_LOCAL_PATH = 'budget';
const RATE_APPLIES_TO_PATH = 'rateAppliesTo';
const PROGRAM_INCOME_PATH = 'nonFederal.programIncome';
const DEFAULT_NONFEDERAL = {
  applicant: 0,
  state: 0,
  other: 0,
  programIncome: 0,
  constructionProgramIncome: 0,
};

export class BudgetSummaryListenerV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      executing: false,
    };
  }

  updateBudget = (newBudget) => {
    // Broke down to several calls due to ovewriding issue when add non fed share in Budget Summary Table
    if (this.props.saveSessionOnly) {
      this.props.saveEntitySessionData(
        (this.props.entityDataPath || `context.${this.props.entityType}`) +
          '.payload' +
          (this.props.customBudgetPayloadPath
            ? `.${this.props.customBudgetPayloadPath}`
            : '') +
          '.budget.share',
        newBudget.share
      );
      this.props.saveEntitySessionData(
        (this.props.entityDataPath || `context.${this.props.entityType}`) +
          '.payload' +
          (this.props.customBudgetPayloadPath
            ? `.${this.props.customBudgetPayloadPath}`
            : '') +
          '.budget.budgetSummary',
        newBudget.budgetSummary
      );
      this.props.saveEntitySessionData(
        (this.props.entityDataPath || `context.${this.props.entityType}`) +
          '.payload' +
          (this.props.customBudgetPayloadPath
            ? `.${this.props.customBudgetPayloadPath}`
            : '') +
          '.budget.extras',
        newBudget.extras
      );
      if (
        this.props.includeDefaultNonFederal &&
        _.isUndefined(this.props.budget, 'nonFederal')
      ) {
        this.props.saveEntitySessionData(
          (this.props.entityDataPath || `context.${this.props.entityType}`) +
            '.payload' +
            (this.props.customBudgetPayloadPath
              ? `.${this.props.customBudgetPayloadPath}`
              : '') +
            '.budget.nonFederal',
          DEFAULT_NONFEDERAL
        );
      }
    } else {
      // Saving share
      if (
        _.isEmpty(this.props.costShare) ||
        (!_.isEmpty(this.props.costShare) &&
          !_.isEqual(this.props.costShare.alternateCostShare, 'Yes'))
      ) {
        this.props.saveEntityData(
          (this.props.entityDataPath || `context.${this.props.entityType}`) +
            '.payload' +
            (this.props.customBudgetPayloadPath
              ? `.${this.props.customBudgetPayloadPath}`
              : '') +
            '.budget.share',
          this.props.entityType,
          newBudget.share,
          BUDGET_LOCAL_PATH
        );
      }
      // Saving budget summary
      this.props.saveEntityData(
        (this.props.entityDataPath || `context.${this.props.entityType}`) +
          '.payload' +
          (this.props.customBudgetPayloadPath
            ? `.${this.props.customBudgetPayloadPath}`
            : '') +
          '.budget.budgetSummary',
        this.props.entityType,
        newBudget.budgetSummary,
        BUDGET_LOCAL_PATH
      );
      // Saving extras
      this.props.saveEntityData(
        (this.props.entityDataPath || `context.${this.props.entityType}`) +
          '.payload' +
          (this.props.customBudgetPayloadPath
            ? `.${this.props.customBudgetPayloadPath}`
            : '') +
          '.budget.extras',
        this.props.entityType,
        newBudget.extras,
        BUDGET_LOCAL_PATH
      );
      // Saving nonFederal
      if (
        this.props.includeDefaultNonFederal &&
        _.isUndefined(this.props.budget, 'nonFederal')
      ) {
        this.props.saveEntityData(
          (this.props.entityDataPath || `context.${this.props.entityType}`) +
            '.payload' +
            (this.props.customBudgetPayloadPath
              ? `.${this.props.customBudgetPayloadPath}`
              : '') +
            '.budget.nonFederal',
          this.props.entityType,
          DEFAULT_NONFEDERAL,
          BUDGET_LOCAL_PATH
        );
      }
    }
    //TODO: this should be serialized to after server response via promise but
    //  works with current low contention usage pattern
    this.setState({executing: false});
  };

  shouldUpdateBudget = (newBudget, oldBudget, prevProps) => {
    let budgetSummaryDiffers = !_.isEqual(
      _.get(newBudget, 'budgetSummary'),
      _.get(oldBudget, 'budgetSummary')
    );
    let shareDiffers = !_.isEqual(_.get(newBudget, 'share'), _.get(oldBudget, 'share'));
    let altCostShareIsNotYesAndDiffersFromPrevProps =
      !_.isEqual(_.get(this.props, 'costShare.alternateCostShare'), 'Yes') &&
      !_.isEqual(
        _.get(prevProps, 'costShare.alternateCostShare'),
        _.get(this.props, 'costShare.alternateCostShare')
      );
    if (
      !_.isEmpty(this.props.costShare) &&
      !_.isEmpty(this.props.costShare.alternateCostShare) &&
      !_.isEmpty(prevProps.costShare)
    ) {
      const shouldUpdate =
        budgetSummaryDiffers ||
        shareDiffers ||
        altCostShareIsNotYesAndDiffersFromPrevProps;
      return shouldUpdate;
    } else {
      const shouldUpdate = budgetSummaryDiffers || shareDiffers;
      return shouldUpdate;
    }
  };

  isInitializing = () => {
    const appShareBreakdown = _.get(this.props.budget, APPSHARE_BREAKDOWN_PATH);
    return appShareBreakdown === undefined || !Array.isArray(appShareBreakdown);
  };

  isAppShareUpdated = (prevProps) =>
    !_.isEqual(
      _.get(this.props.budget, APPSHARE_BREAKDOWN_PATH),
      _.get(prevProps.budget, APPSHARE_BREAKDOWN_PATH)
    ) && _.get(this.props.budget, APPSHARE_UPDATED_PATH);

  isIneligible = (fsItem) => {
    // Checking to see if item is Ineligible
    const result = _.get(fsItem, 'additionalInformation.ineligible');
    return result;
  };

  filterEligibleChildren = (fundingStreams) => {
    if (typeof fundingStreams !== 'object') {
      return fundingStreams;
    }

    const filteredChildren = {};

    for (const [key, childvalue] of Object.entries(fundingStreams)) {
      if (this.isIneligible(childvalue)) {
        continue;
      }

      if (typeof childvalue === 'object') {
        filteredChildren[key] = this.processItemRecursively(childvalue);
      } else {
        filteredChildren[key] = childvalue;
      }
    }

    return filteredChildren;
  };

  // Recursive func to check the items of the funding streams eligibility
  processItemRecursively = (item) => {
    if (item.children) {
      item.children = this.filterEligibleChildren(item.children);
    }

    return item;
  };

  componentDidUpdate(prevProps) {
    const {
      budget,
      fundingStreams: fundingStreamss,
      config,
      foConfig,
      waiverRequested,
      costShareInformation,
      costShare, // direct program dependency
      overwrite,
      data,
      managementCostItemCodes,
      foHandleProgIncome,
    } = this.props;

    const {toggles} = _.get(this.props.context, 'toggles');
    /*
     * If user has selected Yes they qualify for an alternate cost share
     * in the DynamicCostShare section, then they are entering the share
     * values directly and there is nothing to calculate.
     * GMMGO-63918 - fixes blank page issue (too many calls)
     */
    if (_.get(costShare, 'alternateCostShare', 'No') === 'Yes') {
      return;
    }

    // Creating a clone of incoming fundingStreams to be able to filter through
    let filteredFS = _.cloneDeep(fundingStreamss);
    const fundingStreams = this.filterEligibleChildren(filteredFS);

    const isCostShareApproved = (costShare) => {
      if (costShare) {
        const {waiverDetermination} = costShare;

        return (
          (waiverRequested === true || waiverRequested === 'Yes') &&
          waiverDetermination === 'Approved'
        );
      }
      return false;
    };
    if (!this.state.executing && _.isEmpty(budget)) {
      // Create and save budget item
      this.setState({executing: true}, () =>
        this.updateBudget({budgetSummary: {}, share: {}})
      );
    } else if (!this.state.executing && budget && fundingStreams && foConfig) {
      const bocs = BOCS;
      let rateAppliesTo = BudgetUtils.getAppShareRatesBasedOn(foConfig, fundingStreams);
      if (_.isEmpty(rateAppliesTo) || _.isUndefined(rateAppliesTo))
        rateAppliesTo = _.get(config, RATE_APPLIES_TO_PATH);
      const applicantCostShareRate = BudgetUtils.getDefaultAppShareRatesByActivity(
        foConfig,
        fundingStreams,
        rateAppliesTo
      );

      const defaultFedShareRate = _.map(
        _.first(_.values(applicantCostShareRate), []),
        (rate) => 1 - rate
      );
      //Required for SAFER 2021
      let budgetCalculationMode = _.get(config, 'budgetCalculationMode');
      const budgetSummary = _.get(budget, 'budgetSummary');
      const programIncome = _.get(budget, PROGRAM_INCOME_PATH);
      const constructionProgramIncome = _.get(
        budget,
        'nonFederal.constructionProgramIncome'
      );

      let roundToTheNearestCent = false;
      let roundUp = false;
      let deriveAppRate = false;

      // Required for FY 2018 FPS Grant (in awardRec add extras : { roundToTheNearestCent : true } in db
      // to calculate budget to roundToTheNearestCent. since FY 2018 FPS doesn't have budgetCalculationMode in config file
      // budgetCalculationMode is initialized for this specific grant.
      if (
        this.props.context !== undefined &&
        this.props.context.awardRecommendation !== undefined &&
        this.props.context.awardRecommendation.payload !== undefined &&
        this.props.context.awardRecommendation.payload.budget !== undefined &&
        this.props.context.awardRecommendation.payload.budget.extras !== undefined
      ) {
        roundToTheNearestCent = _.get(
          this.props.context.awardRecommendation.payload.budget.extras,
          'roundToTheNearestCent',
          false
        );
        if (roundToTheNearestCent === true) {
          budgetCalculationMode = {
            roundUp: false,
            roundToNearestCent: true,
            deriveAppRate: true,
            reconciliateWithTotal: true,
            reconcileAppShareWithAward: true,
          };
        }
      }
      //Required for grants that contain a .01 off rounding causing a miscalculation
      //Affects Budget Summary -> 'Total Federal and Non-federal resources' section
      //in applicationDynamicData payload add extras : {roundUp: true, deriveAppRate: true, roundToTheNearestCent: true}
      if (
        this.props.context !== undefined &&
        this.props.context.applicationDynamicData !== undefined &&
        this.props.context.applicationDynamicData.payload !== undefined &&
        this.props.context.applicationDynamicData.payload.budget !== undefined &&
        this.props.context.applicationDynamicData.payload.budget.extras !== undefined
      ) {
        roundToTheNearestCent = _.get(
          this.props.context.applicationDynamicData.payload.budget.extras,
          'roundToTheNearestCent',
          false
        );
        roundUp = _.get(
          this.props.context.applicationDynamicData.payload.budget.extras,
          'roundUp',
          false
        );
        deriveAppRate = _.get(
          this.props.context.applicationDynamicData.payload.budget.extras,
          'deriveAppRate',
          false
        );
        if (roundUp && roundToTheNearestCent && deriveAppRate) {
          budgetCalculationMode = {
            roundUp: true,
            roundToNearestCent: true,
            deriveAppRate: true,
          };
        }
      }
      // End

      let defaultAppShareBreakdown;
      if (budgetCalculationMode && budgetSummary && budgetSummary.totalCharges) {
        const defaultAppShareRate = _.map(
          _.first(_.values(applicantCostShareRate), []),
          (rate) => rate
        );
        const numPeriods = defaultAppShareRate.length;
        const budget = BudgetUtils.calculateBudget(
          budgetCalculationMode,
          numPeriods,
          budgetSummary.totalCharges,
          defaultFedShareRate,
          defaultAppShareRate,
          toggles
        );
        defaultAppShareBreakdown = budget.appShare;
      } else {
        defaultAppShareBreakdown = BudgetUtils.getDefaultAppShare(
          config,
          bocs,
          fundingStreams,
          applicantCostShareRate,
          rateAppliesTo,
          constructionProgramIncome,
          programIncome,
          foHandleProgIncome,
          toggles
        );
      }
      let appShareBreakdown = _.get(
        budget,
        APPSHARE_BREAKDOWN_PATH,
        defaultAppShareBreakdown
      );

      let newBudgetComplete;
      // Whether the applicant share below is an input to the calculation or an
      // output of it. GMMGO-63918.
      let fromAppShare;
      if (
        this.isAppShareUpdated(prevProps) ||
        this.isInitializing() ||
        isCostShareApproved(costShareInformation) ||
        costShareInformation == null
      ) {
        fromAppShare = true;
        if (
          !Array.isArray(appShareBreakdown) ||
          !isCostShareApproved(costShareInformation)
        ) {
          appShareBreakdown = defaultAppShareBreakdown;
        }

        const {toggles} = _.get(this.props.context, 'toggles');
        const toggle = _.includes(toggles, 'GMMGO-55955');

        const progType = _.get(
          this.props.context,
          'fundingOpportunityData.configData.budget.fundingStreamSubType'
        );

        const isRecipientPassSubOrg = _.get(
          this.props.context,
          'fundingOpportunityData.configData.pop.isRecipientPassSubOrg'
        );
        let calculationFundingStream =
          toggle &&
          (_.isEqual(progType, 'HSGP') || _.isEqual(progType, 'NSGP/EMPG/Tribal'))
            ? moveManagementFundingStreams(
                fundingStreams,
                'investment',
                _.get(this.props.data, 'organizationId'),
                isRecipientPassSubOrg
              )
            : fundingStreams;

        const computedBudget = BudgetUtils.computeBudgetFromAppShare(
          bocs,
          calculationFundingStream,
          appShareBreakdown,
          defaultFedShareRate,
          rateAppliesTo,
          constructionProgramIncome,
          managementCostItemCodes,
          programIncome,
          foHandleProgIncome
        );

        if (!!overwrite) {
          newBudgetComplete = _.merge(computedBudget, {
            share: {
              fedRate:
                this.isInitializing() || !isCostShareApproved(costShareInformation)
                  ? defaultFedShareRate
                  : _.get(computedBudget, FEDRATE_PATH),
            },
          });
        } else {
          newBudgetComplete = _.merge(
            _.set(
              _.cloneDeep(this.props.budget),
              APPSHARE_BREAKDOWN_PATH,
              appShareBreakdown
            ),
            computedBudget,
            {
              share: {
                fedRate:
                  this.isInitializing() || !isCostShareApproved(costShareInformation)
                    ? defaultFedShareRate
                    : _.get(computedBudget, FEDRATE_PATH),
              },
            }
          );
        }
      } else {
        fromAppShare = false;
        const computedBudget = BudgetUtils.computeBudgetFromFedRates(
          bocs,
          fundingStreams,
          _.get(budget, FEDRATE_PATH),
          rateAppliesTo,
          constructionProgramIncome,
          managementCostItemCodes
        );

        newBudgetComplete = _.merge(_.cloneDeep(this.props.budget), computedBudget);
      }

      // Check for recipient cost share rules in config
      const recipientCostShareRules = _.get(config, 'recipientCostShareRules');

      if (
        !_.isEmpty(recipientCostShareRules) &&
        !isCostShareApproved(costShareInformation)
      ) {
        const useRoundUpLogic = _.get(config, 'useRoundUpLogic', false);
        let updatedBudgetCalculationMode;
        if (budgetCalculationMode) {
          const reconcileAppShareWithAward = _.get(
            budget,
            'extras.reconcileAppShareWithAward',
            false
          );
          const reconcileAppShareAmount = _.get(
            budget,
            'extras.reconcileAppShareAmount',
            0
          );
          updatedBudgetCalculationMode = {
            ...budgetCalculationMode,
            reconcileAppShareWithAward,
            reconcileAppShareAmount,
          };
        } else {
          updatedBudgetCalculationMode = budgetCalculationMode;
        }

        const params = {
          bocs,
          fundingStreams,
          foConfig,
          data,
          recipientCostShareRules,
          useRoundUpLogic,
          budgetCalculationMode: updatedBudgetCalculationMode,
          rateAppliesTo: 'federal',
          constructionProgramIncome,
          managementCostItemCodes,
        };

        if (this.props.withProgramIncome) {
          params.programIncome = programIncome;
        }
        if (this.props.fedLimitFromPath) {
          params.recipientCostShareRules = recipientCostShareRules.concat({
            defaultPercentValue: _.get(this.props, 'defaultAppRate', 0.25),
            calculationRules: [
              {
                fedShareLimit: _.get(this.props, this.props.fedLimitFromPath, 0),
                applyCappedToAppShare: true,
              },
            ],
          });
        }
        params.toggles = toggles;
        newBudgetComplete = BudgetUtils.completeBudgetFromDataRules(params);
      } else if (fromAppShare) {
        // Only re-assert the breakdown on the path that computed from it. On the
        // fedRates path appShareBreakdown is the *stored* applicant share, which
        // the calculation just superseded; overwriting with it strands the
        // applicant share and breaks appShare + fedShare = totalCharges.
        // GMMGO-63918.
        _.set(newBudgetComplete, 'share.appShare', appShareBreakdown);
      }

      if (this.shouldUpdateBudget(newBudgetComplete, this.props.budget, prevProps)) {
        this.setState({executing: true}, () => this.updateBudget(newBudgetComplete));
      }
    }
  }

  render = () => null;
}

export default connectDynamic(BudgetSummaryListenerV2);
